import { render, staticRenderFns } from "./DoubleRankingTitle.vue?vue&type=template&id=111ed9ac&scoped=true"
import script from "./DoubleRankingTitle.vue?vue&type=script&lang=js"
export * from "./DoubleRankingTitle.vue?vue&type=script&lang=js"
import style0 from "./DoubleRankingTitle.vue?vue&type=style&index=0&id=111ed9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ed9ac",
  null
  
)

export default component.exports